export default "__VITE_ASSET__bsc0h1JJ__"